import {Injectable} from "@angular/core";
import {ApiClient} from "../../../../../tools/api-client";
import {Observable} from "rxjs";
import {GeneratorSentences} from "./generator-sentences.component";

@Injectable()
export class GeneratorSentencesService {

  constructor(private readonly apiClient: ApiClient) {
  }

  getGeneratorSentences(): Observable<GeneratorSentences> {
    return this.apiClient.get<GeneratorSentences>("/api/generator-sentences");
  }

  setGeneratorSentences(sentences: GeneratorSentences): Observable<void> {
    return this.apiClient.put("/api/generator-sentences", sentences);
  }
}
